//Max screen width
export enum Breakpoints {
    DESKTOP = 1440, // 1440+
    TABLET = 1439, // 1024-1439
    MOBILE = 1023, // 0-1023
    HEADER = 1844, // max header width
}
